<template>
  <div
      id="app"
      class="h-100"
      :class="[skinClasses]"
  >
    <div
        v-if="
        !$route.path.includes('approve_ownership') &&
          !$route.path.includes('/files/terms') &&
          !$route.path.includes('/files/risk')&&
          !$route.path.includes('/read-files')
      "
    >
      <component :is="layout">
        <router-view/>
      </component>
      <!-- <div v-if="password != 'H1v3Terminal'">
        <input
          style="width: 200px"
          type="password"
          v-model.trim="enterPassword"
          @keyup.enter="setPassword()"
        />
      </div> -->
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
import {$themeColors, $themeBreakpoints, $themeConfig} from '@themeConfig'
import {provideToast} from 'vue-toastification/composition'
import {watch} from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import {useWindowSize, useCssVar} from '@vueuse/core'

import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  data() {
    return {
      password: this.$store.state.app.password,
      enterPassword: null,
      countries_code: [],
      countries: [],
      showApp: false,
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },

  beforeCreate() {
    // Set colors in theme
    const colors = [
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ]

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
          `--${colors[i]}`,
          document.documentElement,
      ).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
          useCssVar(
              `--breakpoint-${breakpoints[i]}`,
              document.documentElement,
          ).value.slice(0, -2),
      )
    }

    // Set RTL
    const {isRTL} = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  created() {
    setTimeout(() => {
      const id = this.$store.state.auth.user.id;
      const token = this.$store.state.auth.user.token

      if (id) {
        this.$http
            .post(`/check_login_trigger/${id}`, {token})
            .then(res => {
              if (res.data && !res.data.value) {
                this.$store.commit('auth/SET_USER', [])
                this.$store.commit('auth/SET_AUTHENTICATED', false)
                this.$store.commit('auth/UPDATE_TOKEN', null)
                window.location.href = '/login'
              }
            })
      }
    }, 3000)
    this.$http.post('/countries').then(res => {
      res.data.value.map(item => {
        this.countries_code.push(item)
        this.countries.push({
          value: item.iso_code,
          text: `${item.iso_code} (${item.phone_code})`,
        })
      })
      setTimeout(() => {
        this.$store.commit('app/SET_COUNTRIES_LIST', this.countries)
        this.$store.commit('app/SET_COUNTRIES_CODE_LIST', this.countries_code)
      }, 3000)
    })
  },
  methods: {
    setPassword() {
      if (this.enterPassword === 'H1v3Terminal') {
        this.password = this.enterPassword
        this.$store.commit('app/UPDATE_PASSWORD', this.password)
      } else {
        alert('Password incorrect.')
      }
    },
  },
  setup() {
    const {skin, skinClasses} = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const {width: windowWidth} = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
